<div class="logo-container">
	<img class="img" src="/assets/img/logo-adobesign.jpg" />
	<img class="text" src="/assets/img/logo-adobesign-text.jpg" />
</div>

<div class="loading-container" *ngIf="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<!-- STEP 1 -->
<div [ngClass]="{'hidden': loading || step !== 1}">
	<div class="text-container">Authenticate against Adobe Acrobat Sign to start sending signatures.</div>
	<div class="button-container" *ngIf="!loading">
		<button (click)="authenenticateAdobeSign()">Authenticate Adobe Sign</button>
	</div>
</div>